module.exports = __webpack_public_path__ + "img/cp-07.adbce64a.png";